import { createContext } from 'react'

export const CSSResetContext = createContext(true)
